import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Hand, Eye, Scissors, Sparkles, GraduationCap, Activity, Wind, Dumbbell, Flame } from 'lucide-react';
export function Services() {
  const handleBooking = () => {
    window.open('https://studiomery.koob.uy', '_blank', 'noopener,noreferrer');
  };
  const beautyServices = [{
    icon: <Hand className="w-6 h-6" data-id="element-214" />,
    title: 'Nails',
    desc: 'Uñas esculpidas, gel, nail art'
  }, {
    icon: <Eye className="w-6 h-6" data-id="element-215" />,
    title: 'Lashes',
    desc: 'Extensiones y lifting de pestañas'
  }, {
    icon: <Scissors className="w-6 h-6" data-id="element-216" />,
    title: 'Brows',
    desc: 'Diseño y laminado de cejas'
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-217" />,
    title: 'Faciales',
    desc: 'Tratamientos faciales premium'
  }, {
    icon: <GraduationCap className="w-6 h-6" data-id="element-218" />,
    title: 'Masterclass',
    desc: 'Cursos y capacitaciones profesionales'
  }];
  const wellnessServices = [{
    icon: <Activity className="w-6 h-6" data-id="element-219" />,
    title: 'Masaje Terapéutico',
    desc: 'Alivio de contracturas y tensión muscular'
  }, {
    icon: <Wind className="w-6 h-6" data-id="element-220" />,
    title: 'Masaje Relajante',
    desc: 'Desconexión total, cuerpo y mente'
  }, {
    icon: <Dumbbell className="w-6 h-6" data-id="element-221" />,
    title: 'Masaje Deportivo',
    desc: 'Recuperación y rendimiento físico'
  }, {
    icon: <Flame className="w-6 h-6" data-id="element-222" />,
    title: 'Masaje con Piedras',
    desc: 'Termoterapia profunda'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="servicios" className="py-24 bg-white" data-id="element-223">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
        <div className="text-center mb-16" data-id="element-225">
          <h2 className="text-sm font-medium text-rosegold tracking-widest uppercase mb-3" data-id="element-226">
            Nuestros Servicios
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-charcoal mb-4" data-id="element-227">
            Belleza & Bienestar
          </h3>
          <p className="text-charcoal-light max-w-2xl mx-auto text-lg font-light" data-id="element-228">
            Descubrí nuestra carta de tratamientos diseñados para cuidar de vos
            de pies a cabeza.
          </p>
        </div>

        {/* Belleza Category */}
        <div className="mb-20" data-id="element-229">
          <div className="flex items-center gap-4 mb-8" data-id="element-230">
            <h4 className="text-2xl font-serif text-charcoal" data-id="element-231">
              Categoría 1 — Belleza
            </h4>
            <div className="h-px bg-cream-dark flex-grow" data-id="element-232"></div>
          </div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-233">
            {beautyServices.map((service, idx) => <motion.div key={idx} variants={itemVariants} className="group bg-cream p-8 rounded-2xl hover:bg-rosegold transition-colors duration-300 cursor-pointer border border-transparent hover:border-rosegold-light shadow-sm hover:shadow-md" onClick={handleBooking} data-id="element-234">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-rosegold group-hover:text-rosegold group-hover:bg-white mb-6 transition-colors" data-id="element-235">
                  {service.icon}
                </div>
                <h5 className="text-xl font-medium text-charcoal group-hover:text-white mb-2 transition-colors" data-id="element-236">
                  {service.title}
                </h5>
                <p className="text-charcoal-light group-hover:text-white/90 font-light mb-6 transition-colors" data-id="element-237">
                  {service.desc}
                </p>
                <button className="text-sm font-medium text-rosegold group-hover:text-white flex items-center gap-1 transition-colors" data-id="element-238">
                  Ver más{' '}
                  <span className="group-hover:translate-x-1 transition-transform" data-id="element-239">
                    →
                  </span>
                </button>
              </motion.div>)}
          </motion.div>
        </div>

        {/* Bienestar Category */}
        <div data-id="element-240">
          <div className="flex items-center gap-4 mb-8" data-id="element-241">
            <h4 className="text-2xl font-serif text-charcoal" data-id="element-242">
              Categoría 2 — Bienestar
            </h4>
            <div className="h-px bg-cream-dark flex-grow" data-id="element-243"></div>
          </div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-244">
            {wellnessServices.map((service, idx) => <motion.div key={idx} variants={itemVariants} className="group bg-cream-dark/50 p-8 rounded-2xl hover:bg-charcoal transition-colors duration-300 cursor-pointer border border-transparent hover:border-charcoal-light shadow-sm hover:shadow-md" onClick={handleBooking} data-id="element-245">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-charcoal group-hover:text-charcoal group-hover:bg-white mb-6 transition-colors" data-id="element-246">
                  {service.icon}
                </div>
                <h5 className="text-xl font-medium text-charcoal group-hover:text-white mb-2 transition-colors" data-id="element-247">
                  {service.title}
                </h5>
                <p className="text-charcoal-light group-hover:text-white/80 font-light text-sm mb-6 transition-colors" data-id="element-248">
                  {service.desc}
                </p>
                <button className="text-sm font-medium text-charcoal group-hover:text-white flex items-center gap-1 transition-colors" data-id="element-249">
                  Ver más{' '}
                  <span className="group-hover:translate-x-1 transition-transform" data-id="element-250">
                    →
                  </span>
                </button>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}